export const springSnappy = {
  type: "spring" as const,
  stiffness: 500,
  damping: 30,
  mass: 0.6,
};

export const springDefault = {
  type: "spring" as const,
  stiffness: 400,
  damping: 32,
  mass: 0.8,
};

export const springGentle = {
  type: "spring" as const,
  stiffness: 300,
  damping: 28,
  mass: 0.9,
};
